import axios from 'axios'
import getCookie from '../scripts/getCookie'

const actionsWithApi = async (method, url, data) => {
    let token = getCookie("token");
    try {
        let response = await axios({
            method: method,
            url: url,
            data: data && JSON.stringify(data),
            headers: token ? {
                'Authorization': 'Bearer ' + token,
                'Access-Control-Allow-Origin': '*',
                'content-type': 'application/json; charset=utf-8',
            } : { 'Content-Type': 'application/json', 'Accept': '*/* ', 'Access-Control-Allow-Origin': '*' },
            withCredentials: true,
        });

        return response;
    } catch (error) {
        var message = error.response.data.Message || error.message;
        if (error.response.status >= 400 && error.response.status < 500) {
            message = (error.response.data || '').toString();
        }
        throw new Error(message);
    }
};


export default actionsWithApi